import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\CremagestAvailabilityController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CremagestAvailabilityController.php
* @route '/api/partners/cremagest/availability'
*/
const CremagestAvailabilityController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CremagestAvailabilityController.url(options),
    method: 'get',
})

CremagestAvailabilityController.definition = {
    methods: ["get","head"],
    url: '/api/partners/cremagest/availability',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\CremagestAvailabilityController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CremagestAvailabilityController.php
* @route '/api/partners/cremagest/availability'
*/
CremagestAvailabilityController.url = (options?: RouteQueryOptions) => {
    return CremagestAvailabilityController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\CremagestAvailabilityController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CremagestAvailabilityController.php
* @route '/api/partners/cremagest/availability'
*/
CremagestAvailabilityController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CremagestAvailabilityController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\CremagestAvailabilityController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CremagestAvailabilityController.php
* @route '/api/partners/cremagest/availability'
*/
CremagestAvailabilityController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: CremagestAvailabilityController.url(options),
    method: 'head',
})

export default CremagestAvailabilityController